/**
 * Pure utility function to build thread identity and mode
 *
 * @param {string} mode - User mode (anonymous/starter/business/standalone)
 * @param {string} visitUuid - Visit UUID (required for anonymous/standalone)
 * @param {string} userUuid - User UUID (required for starter/business)
 * @param {string} businessEntityUuid - Business entity UUID (required for business)
 * @returns {object} { identity, threadMode }
 * @throws {Error} If required UUIDs are missing or mode is unknown
 */
import { THREAD_MODES } from '#client/components/utils/constants';

export function buildThreadIdentity(mode, visitUuid, userUuid, businessEntityUuid) {
  switch (mode) {
    case THREAD_MODES.ANONYMOUS:
      if (!visitUuid) {
        throw new Error('Visit UUID is required for anonymous mode');
      }
      return {
        identity: { visitor: { visitUuid } },
        threadMode: THREAD_MODES.ANONYMOUS
      };

    case THREAD_MODES.STANDALONE:
      if (!visitUuid) {
        throw new Error('Visit UUID is required for standalone mode');
      }
      return {
        identity: { visitor: { visitUuid } },
        threadMode: THREAD_MODES.STANDALONE
      };

    case THREAD_MODES.STARTER:
      if (!userUuid) {
        throw new Error('User UUID is required for starter mode');
      }
      return {
        identity: { customer: { userUuid } },
        threadMode: THREAD_MODES.STARTER
      };

    case THREAD_MODES.BUSINESS:
      if (!userUuid || !businessEntityUuid) {
        throw new Error('User UUID and business entity UUID are required for business mode');
      }
      return {
        identity: { customer: { userUuid, businessEntityUuid } },
        threadMode: THREAD_MODES.BUSINESS
      };

    default:
      throw new Error(`Unknown user mode: ${mode}`);
  }
}
